import { render, staticRenderFns } from "./PlateStockPctOnPlate.vue?vue&type=template&id=0e2968c2&scoped=true"
import script from "./PlateStockPctOnPlate.vue?vue&type=script&lang=js"
export * from "./PlateStockPctOnPlate.vue?vue&type=script&lang=js"
import style0 from "./PlateStockPctOnPlate.vue?vue&type=style&index=0&id=0e2968c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2968c2",
  null
  
)

export default component.exports